// extracted by mini-css-extract-plugin
module.exports = {"modal_root":"ReorderCategories_modal_root__bOR3_","container":"ReorderCategories_container__vnmyG","dragable_item":"ReorderCategories_dragable_item__38rFz"};